// re-deploy
import React from "react";
const shopTestSubscriptions = {
    monthly: [
        {
            merchandiseId: `gid://shopify/ProductVariant/42779486847156`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1217822900',
            amount: 50
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/42816414613684`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1217822900',
            amount: 100
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/42816416710836`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1217822900',
            amount: 250
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/42894197653684`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1217822900',
            amount: 500
        },
    ],
    yearly: [
        {
            merchandiseId: `gid://shopify/ProductVariant/42890709598388`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1247903924',
            amount: 500
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/42890710974644`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1247903924',
            amount: 1000
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/42890710089908`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1247903924',
            amount: 2500
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/43010442494132`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1247903924',
            amount: 5000
        },
    ],
    daily: [
        {
            merchandiseId: `gid://shopify/ProductVariant/42928034906292`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1292730548',
            amount: 50
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/42928034939060`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1292730548',
            amount: 100
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/42928034971828`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1292730548',
            amount: 250
        },
    ],
    oneOff: [
        {
            amount: 100,
            id: 1,
        },
        {
            amount: 500,
            id: 2,
        },
        {
            amount: 1000,
            id: 3,
        },
        {
            amount: null,
            id: 4,
            isCustomAmount: true,
        }
    ],
    default: {
        merchandiseId: `gid://shopify/ProductVariant/42779486847156`,
        quantity: 1,
        sellingPlanId: 'gid://shopify/SellingPlan/1217822900'
    },
    zeroCostItem: {
        variantId: `gid://shopify/ProductVariant/42806479847604`,
        quantity: 1,
    }
}

const prodSubscriptions = {
    monthly: [
        {
            merchandiseId: `gid://shopify/ProductVariant/43927702306993`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1593573553',
            amount: 50
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/43927702339761`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1593573553',
            amount: 100
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/43927702372529`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1593573553',
            amount: 250
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/43927702405297`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1593573553',
            amount: 500
        }
    ],
    yearly: [
        {
            merchandiseId: `gid://shopify/ProductVariant/43927727145137`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1593540785',
            amount: 500
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/43927727177905`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1593540785',
            amount: 1000
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/43927727210673`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1593540785',
            amount: 2500
        },
        {
            merchandiseId: `gid://shopify/ProductVariant/43927727243441`,
            quantity: 1,
            sellingPlanId: 'gid://shopify/SellingPlan/1593540785',
            amount: 5000
        },
    ],
    daily: [],
    oneOff: [
        {
            amount: 100,
            id: 1,
        },
        {
            amount: 500,
            id: 2,
        },
        {
            amount: 1000,
            id: 3,
        },
        {
            amount: null,
            id: 4,
            isCustomAmount: true,
        }
    ],
    default: {
        merchandiseId: `gid://shopify/ProductVariant/43927702306993`,
        quantity: 1,
        sellingPlanId: 'gid://shopify/SellingPlan/1593573553',
    },
    zeroCostItem: {
        variantId: `gid://shopify/ProductVariant/43927634739377`,
        quantity: 1,
    }
}

const shopTestShippingProtectionFees = [
    {
        min: 0,
        max: 499,
        shippingFee: 5,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/43830109339828',
            quantity: 1
        }
    },
    {
        min: 500,
        max: 899,
        shippingFee: 10,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/43830109372596',
            quantity: 1
        }

    },
    {
        min: 900,
        max: 2299,
        shippingFee: 20,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/43830109405364',
            quantity: 1
        }
    },
    {
        min: 2300,
        max: 3299,
        shippingFee: 25,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/43830109438132',
            quantity: 1
        }
    },
    {
        min: 3300,
        max: 4999,
        shippingFee: 35,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/43830109470900',
            quantity: 1
        }
    },
    {
        min: 5000,
        max: 9999999,
        shippingFee: 40,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/43830109503668',
            quantity: 1
        }
    },
]

const prodShippingProtectionFees = [
    {
        min: 0,
        max: 499,
        shippingFee: 5,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/45341008953521',
            quantity: 1
        }
    },
    {
        min: 500,
        max: 899,
        shippingFee: 10,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/45341008986289',
            quantity: 1
        }

    },
    {
        min: 900,
        max: 2299,
        shippingFee: 20,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/45341009019057',
            quantity: 1
        }
    },
    {
        min: 2300,
        max: 3299,
        shippingFee: 25,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/45341009051825',
            quantity: 1
        }
    },
    {
        min: 3300,
        max: 4999,
        shippingFee: 35,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/45341009084593',
            quantity: 1
        }
    },
    {
        min: 5000,
        max: 9999999,
        shippingFee: 40,
        shopifyObject: {
            merchandiseId: 'gid://shopify/ProductVariant/45341009117361',
            quantity: 1
        }
    },
]

const envs = {
    dev: {
        preview_theme_id: 'preview_theme_id=122842022068',
        host_rebag: "https://web.dressingbee.beta.rebag.com",
        host_rebag_shop: "https://shop-test.rebag.com",
        host_rebag_vault: "https://rebag.com/thevault",
        host_rebag_api: "https://web.dressingbee.beta.rebag.com/api",
        bc_shop: "devtrendlee.myshopify.com",
        gb_collection: "ProductsStaging",
        gb_area: "Staging",
        flagsmith_key: "G2oPkXRDFkbRB8WE57iqqE",
        bc_new_arrivals_collection_scope: "33120483",
        storefront_api: {
            apiVersion: '2024-01',
            domain: 'shop-test.rebag.com',
            storefrontAccessToken: 'fdb7dcc8f81339bc5f70ea40f73863a4',
            secret_key: 'f57d7b11c4546ec93b00fcf84aa903e3'
        },
        subscriptions: shopTestSubscriptions,
        shippingProtectionFees: shopTestShippingProtectionFees,
        static_media: "https://web.dressingbee.beta.rebag.com",
        MEDIA_URL: "https://web.dressingbee.beta.rebag.com/static",
        affirm_config: {
            public_api_key: "OPRFJKQ8G8G2JEI0", /* Affirm Public API Key */
            script: "https://cdn1.affirm.com/js/v2/affirm.js",
            session_id: "sID"
        },
        rebag_fb_app_id: 1012592802169210,
        recently_viewed_token: 'Token 24973d55e96fe2c5216ae7721f462b8d67b57249',
        invalid_product_variants: [
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDAwMDMwOA==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDAzMzA3Ng==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDA5ODYxMg==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDEzMTM4MA==',
            // 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDg5NDc1NzMwNjU0OA=='
        ],
        gc_key: '6Leb52MhAAAAAHLofMJCoo6Agnc5XRCgFXDHW_pw',
        checkout_experiment_id: 'NiPTu5zMQq26uMmmCviqaQ',
        pdp_variants_labels: {color: 'Color', size: 'Bag Size'},
    },
    "development": {
        preview_theme_id: 'preview_theme_id=37673402455',
        host_rebag: "https://development.stag.rebag.com",
        host_rebag_shop: "https://shop-test.rebag.com",
        host_rebag_vault: "https://rebag.com/thevault",
        host_rebag_api: "https://development.stag.rebag.com/api",
        bc_shop: "devtrendlee.myshopify.com",
        gb_collection: "ProductsStaging",
        gb_area: "Staging",
        flagsmith_key: "G2oPkXRDFkbRB8WE57iqqE",
        bc_new_arrivals_collection_scope: "17987005",
        storefront_api: {
            apiVersion: '2024-01',
            domain: 'shop-test.rebag.com',
            storefrontAccessToken: 'fdb7dcc8f81339bc5f70ea40f73863a4',
            secret_key: 'f57d7b11c4546ec93b00fcf84aa903e3'
        },
        subscriptions: shopTestSubscriptions,
        shippingProtectionFees: shopTestShippingProtectionFees,
        static_media: "",
        MEDIA_URL: "https://staticfiles.rebag.com/rebag-fe/development",
        affirm_config: {
            public_api_key: "OPRFJKQ8G8G2JEI0", /* Affirm Public API Key */
            script: "https://cdn1.affirm.com/js/v2/affirm.js",
            session_id: "sID"
        },
        rebag_fb_app_id: 1012592802169210,
        recently_viewed_token: 'Token 24973d55e96fe2c5216ae7721f462b8d67b57249',
        invalid_product_variants: [
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDAwMDMwOA==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDAzMzA3Ng==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDA5ODYxMg==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDEzMTM4MA==',
        ],
        gc_key: '6Leb52MhAAAAAHLofMJCoo6Agnc5XRCgFXDHW_pw',
        checkout_experiment_id: 'NiPTu5zMQq26uMmmCviqaQ',
        pdp_variants_labels: {color: 'Color', size: 'Bag Size'},
    },
    prod: {
        preview_theme_id: null,
        host_rebag: "https://www.rebag.com",
        host_rebag_shop: "https://shop.rebag.com",
        host_rebag_vault: "https://www.rebag.com/thevault",
        host_rebag_api: "https://api.rebag.com/api",
        bc_shop: "trendlee.myshopify.com",
        gb_collection:  "ProductsProduction",
        gb_area: "ProductionRb",
        flagsmith_key: "Ce6wh9VzpT5DczTQvriNDV",
        bc_new_arrivals_collection_scope: "17987005",
        storefront_api: {
            apiVersion: '2024-01',
            domain: 'shop.rebag.com',
            storefrontAccessToken: '4f09e4cf50994feca1d67d3d4eff905f',
            secret_key: '2e98e704ab49083ad3a7dfa4fe4d4127'
        },
        subscriptions: prodSubscriptions,
        shippingProtectionFees: prodShippingProtectionFees,
        static_media: "",
        MEDIA_URL: "https://staticfiles.rebag.com/rebag-fe/prod",
        affirm_config: {
            public_api_key: "OPRFJKQ8G8G2JEI0", /* Affirm Public API Key */
            script: "https://cdn1.affirm.com/js/v2/affirm.js",
            session_id: "sID"
        },
        rebag_fb_app_id: 1730493947167882,
        recently_viewed_token: 'Token 24973d55e96fe2c5216ae7721f462b8d67b57249',
        invalid_product_variants: [
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTA2NTUxMzM1MzM5Mw==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTA2NTUxMzM4NjE2MQ==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTA2NTUxMzQxODkyOQ==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTA2NTUxMzQ1MTY5Nw==',
        ],
        gc_key: '6Leb52MhAAAAAHLofMJCoo6Agnc5XRCgFXDHW_pw',
        checkout_experiment_id: 'lP7m4SEuSBebZzkcQ0ldFQ',
        pdp_variants_labels: {color: 'Color', size: 'Bag Size'},
    },
    cached: {
        preview_theme_id: null,
        host_rebag: "https://cached.rebag.com",
        host_rebag_shop: "https://shop.rebag.com",
        host_rebag_vault: "https://rebag.com/thevault",
        host_rebag_api: "https://api.rebag.com/api",
        bc_shop: "trendlee.myshopify.com",
        gb_collection:  "ProductsProduction",
        gb_area: "ProductionRb",
        flagsmith_key: "Ce6wh9VzpT5DczTQvriNDV",
        bc_new_arrivals_collection_scope: "17987005",
        storefront_api: {
            apiVersion: '2024-01',
            domain: 'shop.rebag.com',
            storefrontAccessToken: '4f09e4cf50994feca1d67d3d4eff905f',
            secret_key: '2e98e704ab49083ad3a7dfa4fe4d4127'
        },
        subscriptions: prodSubscriptions,
        shippingProtectionFees: prodShippingProtectionFees,
        static_media: "",
        MEDIA_URL: "https://staticfiles.rebag.com/rebag-fe/cached",
        affirm_config: {
            public_api_key: "OPRFJKQ8G8G2JEI0", /* Affirm Public API Key */
            script: "https://cdn1.affirm.com/js/v2/affirm.js",
            session_id: "sID"
        },
        rebag_fb_app_id: 1730493947167882,
        recently_viewed_token: 'Token 24973d55e96fe2c5216ae7721f462b8d67b57249',
        invalid_product_variants: [
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTA2NTUxMzM1MzM5Mw==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTA2NTUxMzM4NjE2MQ==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTA2NTUxMzQxODkyOQ==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTA2NTUxMzQ1MTY5Nw==',
        ],
        gc_key: '6Leb52MhAAAAAHLofMJCoo6Agnc5XRCgFXDHW_pw',
        pdp_variants_labels: {color: 'Color', size: 'Bag Size Hidden'},
    },
    "dcstaging": {
        preview_theme_id: `preview_theme_id=${process.env.REACT_APP_PREVIEW_THEME_ID}`,
        host_rebag: `https://${process.env.REACT_APP_FLAVOR}.stag.rebag.com`,
        host_rebag_shop: `${process.env.REACT_APP_USE_PROD_SHOP ? "https://shop.rebag.com" : "https://shop-test.rebag.com"}`,
        host_rebag_vault: "https://www.rebag.com/thevault",
        host_rebag_api: `https://${process.env.REACT_APP_FLAVOR}.stag.rebag.com/api`,
        bc_shop: `${process.env.REACT_APP_USE_PROD_SHOP ? "trendlee.myshopify.com" : "devtrendlee.myshopify.com"}`,
        gb_collection: `${process.env.REACT_APP_USE_PROD_SHOP ? "ProductsProduction" : "ProductsStaging"}`,
        gb_area: `${process.env.REACT_APP_USE_PROD_SHOP ? "ProductionRb" : "Staging"}`,
        flagsmith_key: `${process.env.REACT_APP_USE_PROD_SHOP ? "Ce6wh9VzpT5DczTQvriNDV" : "G2oPkXRDFkbRB8WE57iqqE"}`,
        bc_new_arrivals_collection_scope: `${process.env.REACT_APP_USE_PROD_SHOP ? "17987005" : "33120483"}`,
        storefront_api: {
            apiVersion: '2024-01',
            domain: `${process.env.REACT_APP_USE_PROD_SHOP ? "shop.rebag.com" : "shop-test.rebag.com"}`,
            storefrontAccessToken: `${process.env.REACT_APP_USE_PROD_SHOP ? "4f09e4cf50994feca1d67d3d4eff905f" : "fdb7dcc8f81339bc5f70ea40f73863a4"}`,
            secret_key: `${process.env.REACT_APP_USE_PROD_SHOP ? "2e98e704ab49083ad3a7dfa4fe4d4127" : "f57d7b11c4546ec93b00fcf84aa903e3"}`,
        },
        subscriptions: process.env.REACT_APP_USE_PROD_SHOP ? prodSubscriptions : shopTestSubscriptions,
        shippingProtectionFees: process.env.REACT_APP_USE_PROD_SHOP ? prodShippingProtectionFees : shopTestShippingProtectionFees,
        static_media: "",
        MEDIA_URL: `https://staticfiles.rebag.com/rebag-fe/${process.env.REACT_APP_FLAVOR}`,
        affirm_config: {
            public_api_key: "OPRFJKQ8G8G2JEI0", /* Affirm Public API Key */
            script: "https://cdn1.affirm.com/js/v2/affirm.js",
            session_id: "sID"
        },
        rebag_fb_app_id: 1012592802169210,
        recently_viewed_token: 'Token 24973d55e96fe2c5216ae7721f462b8d67b57249',
        invalid_product_variants: [
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDAwMDMwOA==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDAzMzA3Ng==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDA5ODYxMg==',
            'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MDc0OTQ1NDEzMTM4MA==',
        ],
        gc_key: '6Leb52MhAAAAAHLofMJCoo6Agnc5XRCgFXDHW_pw',
        checkout_experiment_id: 'NiPTu5zMQq26uMmmCviqaQ',
        pdp_variants_labels: {color: 'Color', size: 'Bag Size'},
    },
};

const config = envs[process.env.REACT_APP_STAGE] || envs["dev"];

const home_mag_items = [
    {
        title: "The Vault",
        href: `${config.host_rebag_vault}`,
        mouse_over: {show_magazine_menu: true},
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true
    }
];

const header_menu_items = [
    {
        key: "for_you",
        url_slug: "for-you",
        title: "For You",
        href: `${config.host_rebag}/for-you`,
        mouse_over: false,
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
    },
    {
        key: "new_arrivals",
        url_slug: "new-arrivals",
        title: "New Arrivals",
        href: `${config.host_rebag_shop}/collections/new-arrivals${config.preview_theme_id ? `?${config.preview_theme_id}` : ""}`,
        mouse_over: false,
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
    },
    {
        key: "designers",
        title: "Designers",
        href: `${config.host_rebag_shop}/collections/`,
        href_new_arrivals: `${config.host_rebag_shop}/collections/new-arrivals`,
        mouse_over: {show_designers_menu: true},
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
        other_filter_key: "pf_v_designers",
        collections_info: {
            title: "Popular",
        }
    },
    {
        key: "bags",
        url_slug: "all-bags",
        title: "Bags",
        href: `${config.host_rebag_shop}/collections/all-bags`,
        href_new_arrivals: `${config.host_rebag_shop}/collections/new-arrivals`,
        sort: '',
        mouse_over: {show_bags_menu: true},
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
        collections_filter_key: 'pf_t_bag_type',
        other_filter_key: 'pf_v_designers',
        extra_filter_key: "pf_t_bag_type",
        mobile_submenu_open_by_default: "1",
        img: `${config.MEDIA_URL}/promos/bags-promo-03.18.2025.jpg`,
        img_url: `${config.host_rebag_shop}/collections/all-bags`,
        collections_info: {
            title: "Featured Designers",
        },
        manual_designers_list: [
            {
                name: "Chanel",
                slug: "chanel"
            },
            {
                name: "Christian Dior",
                slug: "christian-dior"
            },
            {
                name: "Fendi",
                slug: "fendi"
            },
            {
                name: "Goyard",
                slug: "goyard"
            },
            {
                name: "Gucci",
                slug: "gucci"
            },
            {
                name: "Hermes",
                slug: "hermes"
            },
            {
                name: "Louis Vuitton",
                slug: "louis-vuitton"
            },
            {
                name: "Prada",
                slug: "prada"
            },
            {
                name: "Saint Laurent",
                slug: "saint-laurent"
            },
        ],
    },
    {
        key: "jewelry",
        url_slug: "all-jewelry",
        title: "Jewelry",
        href: `${config.host_rebag_shop}/collections/all-jewelry`,
        href_new_arrivals: `${config.host_rebag_shop}/collections/new-arrivals`,
        mouse_over: {show_jewelry_menu: true},
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
        collections_filter_key: 'pf_t_jewelry_type',
        other_filter_key: 'pf_v_designers',
        mobile_submenu_open_by_default: "0",
        img: `${config.MEDIA_URL}/promos/jewelry-promo-03.18.2025.jpg`,
        img_url: `${config.host_rebag_shop}/collections/all-jewelry`,
        collections_info: {
            title: "Featured Designers",
        },
        manual_designers_list: [
            {
                name: "Bvlgari",
                slug: "bvlgari"
            },
            {
                name: "Cartier",
                slug: "cartier"
            },
            {
                name: "Chanel",
                slug: "chanel"
            },
            {
                name: "Gucci",
                slug: "gucci"
            },
            {
                name: "Hermes",
                slug: "hermes"
            },
            {
                name: "Louis Vuitton",
                slug: "louis-vuitton"
            },
            {
                name: "Tiffany & Co.",
                slug: "tiffany-co"
            },
            {
                name: "Van Cleef & Arpels",
                slug: "van-cleef-arpels"
            },
        ],
    },
    {
        key: "watches",
        url_slug: "all-watches",
        title: "Watches",
        href: `${config.host_rebag_shop}/collections/all-watches`,
        href_new_arrivals: `${config.host_rebag_shop}/collections/new-arrivals`,
        mouse_over: {show_watches_menu: true},
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
        collections_filter_key: 'pf_t_watch_case_size',
        other_filter_key: 'pf_v_designers',
        mobile_submenu_open_by_default: "1",
        img: `${config.MEDIA_URL}/promos/watches-promo-03.18.2025.jpg`,
        img_url: `${config.host_rebag_shop}/collections/all-watches`,
        collections_info_key: 'show_in_watches',
        collections_info: {
            title: "Featured Designers",
        },
        manual_designers_list: [
            {
                name: "Breitling",
                slug: "breitling"
            },
            {
                name: "Bvlgari",
                slug: "bvlgari"
            },
            {
                name: "Cartier",
                slug: "cartier"
            },
            {
                name: "Chanel",
                slug: "chanel"
            },
            {
                name: "Hermes",
                slug: "hermes"
            },
            {
                name: "Omega",
                slug: "omega"
            },
            {
                name: "Rolex",
                slug: "rolex"
            },
            {
                name: "Tag Heuer",
                slug: "tag-heuer"
            },
        ],
    },
    {
        key: "shoes",
        url_slug: "all-shoes",
        title: "Shoes",
        href: `${config.host_rebag_shop}/collections/all-shoes`,
        href_new_arrivals: `${config.host_rebag_shop}/collections/new-arrivals`,
        mouse_over: {show_shoes_menu: true},
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
        collections_filter_key: 'pf_t_shoe_type',
        other_filter_key: 'pf_v_designers',
        mobile_submenu_open_by_default: "0",
        img: `${config.MEDIA_URL}/promos/shoes-promo-03.18.2025.jpg`,
        img_url: `${config.host_rebag_shop}/collections/all-shoes`,
        collections_info_key: 'show_in_shoes',
        collections_info: {
            title: "Featured Designers",
        },
        manual_designers_list: [
            {
                name: "Bottega Veneta",
                slug: "bottega-veneta"
            },
            {
                name: "Chanel",
                slug: "chanel"
            },
            {
                name: "Christian Dior",
                slug: "christian-dior"
            },
            {
                name: "Christian Louboutin",
                slug: "christian-louboutin"
            },
            {
                name: "Gucci",
                slug: "gucci"
            },
            {
                name: "Hermes",
                slug: "hermes"
            },
            {
                name: "Louis Vuitton",
                slug: "louis-vuitton"
            },
            {
                name: "Prada",
                slug: "prada"
            },
            {
                name: "Saint Laurent",
                slug: "saint-laurent"
            },
        ],
    },
    {
        key: "accessories",
        url_slug: "all-accessories",
        title: "Accessories",
        href: `${config.host_rebag_shop}/collections/all-accessories`,
        href_new_arrivals: `${config.host_rebag_shop}/collections/new-arrivals`,
        mouse_over: {show_accessories_menu: true},
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
        collections_filter_key: 'pf_t_accessory_type',
        other_filter_key: 'pf_v_designers',
        extra_filter_key: "pf_t_accessory_type",
        mobile_submenu_open_by_default: "1",
        img: `${config.MEDIA_URL}/promos/accessories-promo-03.13.2025.jpg`,
        img_url: `${config.host_rebag_shop}/collections/all-accessories`,
        collections_info: {
            title: "Featured Designers",
        },
        manual_designers_list: [
            {
                name: "Celine",
                slug: "celine"
            },
            {
                name: "Chanel",
                slug: "chanel"
            },
            {
                name: "Christian Dior",
                slug: "christian-dior"
            },
            {
                name: "Fendi",
                slug: "fendi"
            },
            {
                name: "Goyard",
                slug: "goyard"
            },
            {
                name: "Gucci",
                slug: "gucci"
            },
            {
                name: "Hermes",
                slug: "hermes"
            },
            {
                name: "Louis Vuitton",
                slug: "louis-vuitton"
            },
            {
                name: "Saint Laurent",
                slug: "saint-laurent"
            },
        ],
    },
    {
        key: "apparel",
        url_slug: "all-apparel",
        title: "Apparel",
        href: `${config.host_rebag_shop}/collections/all-apparel`,
        href_new_arrivals: `${config.host_rebag_shop}/collections/new-arrivals`,
        mouse_over: {show_apparel_menu: true},
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
        collections_filter_key: 'pf_t_apparel_type',
        other_filter_key: 'pf_v_designers',
        mobile_submenu_open_by_default: "0",
        img: `${config.MEDIA_URL}/promos/apparel-promo-03.13.2025.jpg`,
        img_url: `${config.host_rebag_shop}/collections/all-apparel`,
        collections_info_key: 'show_in_apparel',
        collections_info: {
            title: "Featured Designers",
        },
        manual_designers_list: [
            {
                name: "Burberry",
                slug: "burberry"
            },
            {
                name: "Chanel",
                slug: "chanel"
            },
            {
                name: "Christian Dior",
                slug: "christian-dior"
            },
            {
                name: "Fendi",
                slug: "fendi"
            },
            {
                name: "Gucci",
                slug: "gucci"
            },
            {
                name: "Hermes",
                slug: "hermes"
            },
            {
                name: "Louis Vuitton",
                slug: "louis-vuitton"
            },
            {
                name: "Moncler",
                slug: "moncler"
            },
            {
                name: "Saint Laurent",
                slug: "saint-laurent"
            },
        ],
    },
    {
        key: 'sales',
        url_slug: 'clearance',
        title: "Clearance",
        href: `${config.host_rebag_shop}/collections/clearance`,
        mouse_over: {show_sales_menu: true},
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
        img: `${config.MEDIA_URL}/promos/clearance-promo-07.10.2025.jpg`,
        img_url: `${config.host_rebag_shop}/collections/clearance`,
        collections: [
            {
                title: "Up to 20% off",
                url: `${config.host_rebag_shop}/collections/clearance?pf_t_clearance_discount=bc-filter-Up+to+20%25+off`,
            },
            {
                title: "Up to 30% off",
                url: `${config.host_rebag_shop}/collections/clearance?pf_t_clearance_discount=bc-filter-Up+to+30%25+off`,
            },
            {
                title: "Up to 40% off",
                url: `${config.host_rebag_shop}/collections/clearance?pf_t_clearance_discount=bc-filter-Up+to+40%25+off`,
            },
            {
                title: "Last Call",
                url: `${config.host_rebag_shop}/collections/clearance?pf_t_clearance_discount=bc-filter-Last+Call`,
            },
        ],
    },
    // {
    //     key: "rplus_membership",
    //     url_slug: 'rplus_membership',
    //     title: "Membership",
    //     href: `${config.host_rebag}/membership/`,
    //     mouse_over: false,
    //     show_desktop: true,
    //     show_mobile: true,
    //     show_sidebar: true
    // },
    {
        key: 'wholesale',
        url_slug: 'wholesale',
        title: "Wholesale",
        href: `${config.host_rebag_shop}/collections/wholesale`,
        collections: [
            {
                title: "Wholesale New",
                sub_title: null,
                url: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&pf_st_availability_hidden=true&pf_t_wholesale_discounts=whnew`,
                image: `${config.MEDIA_URL}/img/sale_menu/outlet-nav-11.01.jpg`,
                cta_label: "Shop now"
            },
            {
            //     title: "Wholesale Reduced",
            //     sub_title: null,
            //     url: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&pf_st_availability_hidden=true&pf_t_wholesale_discounts=whreduced`,
            //     image: `${config.MEDIA_URL}/img/sale_menu/outlet-nav-11.01.jpg`,
            //     cta_label: "Shop now"
            // },
            // {
            //     title: "Wholesale Clearance",
            //     sub_title: null,
            //     url: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&pf_st_availability_hidden=true&pf_t_wholesale_discounts=whclearance`,
            //     image: `${config.MEDIA_URL}/img/sale_menu/outlet-nav-11.01.jpg`,
            //     cta_label: "Shop now"
            },
        ],
        // mouse_over: {show_sales_menu: true},
        mouse_over: false,
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
        available_between: ["2024-02-14 13:00:00", "2027-02-27 07:59:59"],
        tooltip: 'Our Wholesale Collection is not available right now. Look for an email from us announcing the next sale.',
    },
    {
        key: "vip-preview",
        title: "Vip Preview",
        href: null,
        mouse_over: false,
        show_desktop: true,
        show_mobile: true,
        show_sidebar: true,
    },
    // {
    //     key: "gifts",
    //     title: "Gifts",
    //     href: `${config.host_rebag}/gift-suite/`,
    //     mouse_over: {show_gifts_menu: true},
    //     show_desktop: true,
    //     show_mobile: true,
    //     show_sidebar: true,
    //     className: "color-red"
    // }
];

const footer_nav_container = [
    {
        id: "1",
        title: "Buy",
        links: [
            {
                label: "For You",
                type: "link",
                url: `${config.host_rebag}/for-you`
            },
            {
                label: "New Arrivals",
                type: "link",
                url: `${config.host_rebag_shop}/collections/new-arrivals`
            },
            {
                label: "Designers",
                type: "link",
                url: `${config.host_rebag_shop}/collections`
            },
            {
                label: "Bags",
                type: "link",
                url: `${config.host_rebag_shop}/collections/all-bags?_=pf&pf_st_availability_hidden=true&pf_t_categories=bc-filter-Bags`
            },
            {
                label: "Watches",
                type: "link",
                url: `${config.host_rebag_shop}/collections/all-watches?sort=created-descending&_=pf&pf_st_availability_hidden=true&pf_t_categories=bc-filter-Watches`,
            },
            {
                label: "Jewelry",
                type: "link",
                url: `${config.host_rebag_shop}/collections/all-jewelry?sort=created-descending&_=pf&pf_st_availability_hidden=true&pf_t_categories=bc-filter-Jewelry`,
            },
            {
                label: "Shoes",
                type: "link",
                url: `${config.host_rebag_shop}/collections/all-shoes`,
            },
            {
                label: "Apparel",
                type: "link",
                url: `${config.host_rebag_shop}/collections/all-apparel`,
            },
            {
                label: "Accessories",
                type: "link",
                url: `${config.host_rebag_shop}/collections/all-accessories?sort=created-descending&_=pf&pf_st_availability_hidden=true&pf_t_categories=bc-filter-Accessories`,
            },
            {
                label: "Clearance",
                type: "link",
                url: `${config.host_rebag_shop}/collections/clearance`,
            },
        ]
    },
    {
        id: "2",
        title: "Sell",
        links: [
            {
                label: "Sell Now",
                type: "link",
                url: `${config.host_rebag}/sell-now/`
            },
            {
                label: "Selling with Rebag",
                type: "link",
                url: `${config.host_rebag}/selling-with-rebag/`
            },
            {
                label: "Consign",
                type: "link",
                url: `${config.host_rebag}/consign/`
            },
            {
                label: "Trade",
                type: "link",
                url: `${config.host_rebag}/trade/`
            },
            {
                label: "Buyout",
                type: "link",
                url: `${config.host_rebag}/buyout/`
            },
            {
                label: "Infinity Exchange",
                type: "link",
                url: `${config.host_rebag}/infinity/`
            },
            {
                label: "Rebag's Most Wanted",
                type: "link",
                url: `${config.host_rebag}/mostwanted/`
            },
            {
                label: "Premium Payouts",
                type: "link",
                url: `${config.host_rebag}/premiumpayouts/`
            },
            {
                label: "Selling Guidelines",
                type: "link",
                url: `${config.host_rebag}/condition_page/`
            },
            {
                label: "Rebag x thredUP",
                type: "link",
                url: `https://rebag.thredup.com/`
            }
        ]
    },
    {
        id: '3',
        title: 'Rebag For Business',
        links: [
            {
                label: "About the Program",
                type: "link",
                url: `${config.host_rebag}/wholesale/`
            },
            {
                label: "Request Access",
                type: "link",
                url: `${config.host_rebag}/join-rebagforbusiness/`,
                id: "wholesale_auth",
                require_auth: true,
            },
            {
                label: "Shop Wholesale",
                type: "b2b",
                url: `${config.host_rebag_shop}/collections/wholesale`,
                available_between: ["2024-02-14 13:00:00", "2027-02-27 07:59:59"],
                b2b_message: 'Our Wholesale Collection is not available right now. Look for an email from us announcing the next sale.',
                regular_message: 'Reserved for Rebag for Business partners. Request Access by clicking on the link directly above.'
            },
        ]
    },
    {
        id: "4",
        title: "Company",
        links: [
            {
                label: "About Us",
                type: "link",
                url: `${config.host_rebag}/about-us/`
            },
            {
                label: "Why Trust Rebag?",
                type: "link",
                url: `${config.host_rebag}/rebagcertified/`
            },
            {
                label: "Rebag⁺",
                type: "link",
                url: `${config.host_rebag}/membership`
            },
            {
                label: "Find a Store",
                type: "link",
                url: `${config.host_rebag}/store/`
            },
            {
                label: "The Vault",
                type: "link",
                url: `${config.host_rebag_vault}`
            },
            {
                label: "The Clair Report",
                type: "link",
                url: `${config.host_rebag}/clair-report/`
            },
            {
                label: "Rebag Stylist",
                type: "link",
                url: `${config.host_rebag}/stylist/`
            },
            {
                label: "Rebag x Bloomingdale's",
                type: "link",
                url: `${config.host_rebag}/bloomingdales/`
            },
        ]
    },
    {
        id: "5",
        title: "Help",
        links: [
            {
                label: "Contact Us",
                type: "link",
                target: '_blank',
                url: "https://support.rebag.com/hc/en-us/articles/360038451531-How-do-I-contact-Rebag"
            },
            {
                label: "FAQs",
                type: "link",
                target: '_blank',
                url: "https://support.rebag.com/hc/en-us"
            },
            {
                label: "Shipping",
                type: "link",
                target: '_blank',
                url: "https://support.rebag.com/hc/en-us/articles/360037853271-Domestic-Shipping-Information"
            },
            {
                label: "Returns",
                type: "link",
                target: '_blank',
                url: "https://support.rebag.com/hc/en-us/articles/360037853551-Does-Rebag-accept-returns"
            },
            {
                label: "Financing",
                type: "link",
                url: `${config.host_rebag}/financing/`
            },
            {
                label: "Work at Rebag",
                type: "link",
                target: '_blank',
                url: "https://boards.greenhouse.io/rebag"
            },
            {
                label: "Accessibility",
                type: "link",
                target: '_blank',
                url: "https://support.rebag.com/hc/en-us/articles/360046920732"
            },
        ]
    }
];

const footer_nav_container_contact = {
    url: `${config.host_rebag}/contact/`,
    email: "contact@rebag.com",
    phone: "1-844-373-7723",
    dedicated_support_phone: "1-844-941-3034",
    schedule_days: "Monday - Friday",
    schedule_hours: "9:00 am to 7:00 pm (EST)",
    social_url_instagram: "https://instagram.com/rebagofficial/",
    social_url_facebook: "https://www.facebook.com/rebagofficial",
    social_url_twitter: "https://twitter.com/officialrebag",
    social_url_youtube: "https://www.youtube.com/@Rebagofficial",
    app_url_apple: "https://itunes.apple.com/us/app/rebagg-cash-for-designer-handbags/id1021869969?mt=8",
    app_url_google: "https://play.google.com/store/apps/details?id=com.rebagg.rebagg&hl=en"
};

const footer_disclaimer_container = {
    disclaimers: [
        {
            id: '1',
            start_date: '2024-09-05',
            end_date: '2024-09-06',
            message: "*Get $25 OFF $600+, $50 OFF $1,250+, $100 OFF $2,000+, $200 OFF $3,000+ online and in stores until 9/09/24 at 11:59pm PT with code SPENDANDSAVE. Combinable with 5% off Rebag+ member pricing, with a minimum of $50 and maximum of $1,000 per item. Cannot be applied to purchases made outside of this time frame. Only one code per purchase.",
            min_tier: 5
        },
        {
            id: '2',
            start_date: '2024-10-24',
            end_date: '2024-10-30',
            message: "*Use code GIFTS online and in stores until 10/29/24 at 11:59pm PT. Combinable with 5% off Rebag+ member pricing, with a minimum of $50 and maximum of $1,000 per item. Cannot be applied to purchases made outside of this time frame. Only one code per purchase.",
            min_tier: 0
        },
        {
            id: '3',
            start_date: '2025-07-10',
            end_date: '2025-08-01',
            message: `*Rates from 0–36% APR. 0% APR promotion is available from 7/10/25 to 7/31/25 11:59pm PT and is available for up to 12 month term lengths for those who qualify. For example, an $1800 purchase might cost $162.47/mo over 12 months at 15% APR. Payment options through Affirm are subject to an eligibility check, may not be available everywhere, and are provided by these lending partners: <a href="http://affirm.com/lenders" target="_blank" rel="noopener noreferrer">Affirm's lending partners</a>. Options depend on your purchase amount, and a down payment may be required. See <a href="http://affirm.com/licenses" target="_blank" rel="noopener noreferrer">Licenses, Notices, and Related Disclosures</a> for important info on state licenses and notifications.`,
            min_tier: 0
        },
        {
            id: '4',
            start_date: '2023-08-17',
            end_date: '2023-08-18',
            message: "*From 8/18/2023 until 8/21/2023 at 11:59pm PT (Pacific Time), spend $500+ to receive $50 Rebag Credit, spend $1,000+ to receive $100 Rebag Credit, spend $2,000+ to receive $200 Rebag Credit, or spend $3,000+ to receive $300 Rebag Credit. Cannot be applied to purchases made outside of this time-frame. Credit earned during this promotion will be deposited into your Rebag Wallet in September and expires 10/31/23. No code necessary. Can be combined with existing credit.",
            min_tier: 2
        },
        {
            id: '5',
            start_date: '2024-05-31',
            end_date: '2024-06-04',
            message: "*From 5/31/24 until 6/03/24 at 11:59pm PT (Pacific Time), spend $500+ to receive $50 Rebag Credit, spend $1,000+ to receive $100 Rebag Credit, spend $2,000+ to receive $200 Rebag Credit, or spend $3,000+ to receive $300 Rebag Credit. Cannot be applied to purchases made outside of this time-frame. Credit earned during this promotion will be deposited into your Rebag Wallet in May and expires 7/07/24. No code necessary. Can be combined with existing credit.",
            min_tier: 0
        },
        {
            id: '6',
            start_date: '2022-09-26',
            end_date: '2024-10-28',
            message: "*Refer program only available for customers in the U.S. Referred friend discount only applicable on first purchase. Rebag Credit will be awarded 14 days after your friend makes their first purchase. Partial or full refunds will prohibit Rebag Credit from being awarded. See terms and conditions for details.",
            min_tier: 0
        },
        {
            id: '7',
            start_date: '2022-12-07',
            end_date: '2025-12-07',
            message: "*Payout will be deposited as Seller Funds in the Wallet section of your Rebag.com account. Transfer your Seller Funds at any time via bank transfer or check. Your Seller Funds cannot be redeemed at stores for physical cash.",
            min_tier: 0
        },
        {
            id: '8',
            start_date: '2025-07-10',
            end_date: '2025-08-10',
            message: `*Earn $500 in Bonus Rebag Credit for each Hermès Birkin or Kelly handbag sold at $10,000 or more (based on the final buying price—Rebag’s offer after in-person inspection). Offer(s) must be accepted and item(s) postmarked by 8/10/2025. Bonus Credit will be issued to the seller’s <a href="https://www.rebag.com/sell-now/" target="_blank" rel="noopener noreferrer">Rebag.com</a> account in August and will be valid for 30 days.`,
            min_tier: 0
        },
    ],
    text: "Rebag is independent from any brand affiliation. Brands are not responsible for any product purchased from the website, and brands do not guarantee the authenticity of goods sold. Certificates are provided solely by Rebag.",
    copyright: "© " + new Date().getFullYear() + " Rebag. All rights reserved.",
    links: [
        {
            id: "1",
            label: "Privacy",
            url: `${config.host_rebag}/terms/#privacy`
        },
        {
            id: "2",
            label: "Terms",
            url: `${config.host_rebag}/terms/`
        },
    ]
};

const homepage_theme_data = {
    sale_name: "<span class=\"hero-copy--title--left\">Fresh</span> <span class=\"hero-copy--title--right\">Take</span>",
    sale_code: "FRESH",
    tier_discounts: [
        {
            amount_discounted: "$30",
            min_amount: "$500+"
        },
        {
            amount_discounted: "$60",
            min_amount: "$1,000+"
        },
        {
            amount_discounted: "$125",
            min_amount: "$2,000+"
        },
        {
            amount_discounted: "$250",
            min_amount: "$3,500+"
        }
    ]
}

const remove_price_collections_list = [
    "Gucci",
    "Prada",
    "Saint Laurent",
    "Fendi",
    "Christian Dior",
    "Celine",
];

const image_sizes = {
    small: 100,
    medium_small: 130,
    medium: 300,
    big: 1500
}

const exotic_materials_list = [
    "Exotic",
    "Alligator",
    "Crocodile",
    "Eel",
    "Lizard",
    "Ostrich",
    "Ostrich Leg",
    "Python",
    "Snakeskin",
    "Stingray"
];

const sell_now_steps_header = [
    {
        title: 1,
        sub_title: "Find your item",
        text: "Identify your item via AI, search, or image submission"
    },
    {
        title: 2,
        sub_title: "Tell its history",
        text: "Provide basic details such as the model, material, and condition"
    },
    {
        title: 3,
        sub_title: "Reveal its value",
        text: "Receive an instant offer for most styles, or get your quote via email within 2 business days"
    },

];

const getReturnPriceBasedOnProductPrice = (productPrice, selectedCountryCode) => {
    let returnValue = "$25";

    if (selectedCountryCode && selectedCountryCode !== "US") {
        return returnValue;
    }

    if (productPrice >= 1000 && productPrice < 3000) {
        returnValue = "$50";
    } else if (productPrice >= 3000 && productPrice < 8000) {
        returnValue = "$75";
    } else if (productPrice >= 8000) {
        returnValue = "$100";
    }

    return returnValue;
}

const internationalShipping = {
    "AU": {
        name: "Australia",
        fee: "AUD $150",
        limit: "AUD $3600",
    },
    "CA": {
        name: "Canada",
        fee: "CAD $75",
        limit: "CAD $3300",
    },
    "GB": {
        name: "United Kingdom",
        fee: "GBP £75",
        limit: "GBP £2000",
    },
    "RO": {
        name: "Romania",
        fee: "RON 550",
        limit: "RON 3000",
    },
    "FR": {
        name: "France",
        fee: "EURO €75",
        limit: "EURO €2400",
    },
    "DE": {
        name: "Germany",
        fee: "EURO €85",
        limit: "EURO €2400",
    },
    "IT": {
        name: "Italy",
        fee: "EURO €60",
        limit: "EURO €2400",
    },
    "CH": {
        name: "Switzerland",
        fee: "CHF 90",
        limit: "CHF 2500",
    },
    "SE": {
        name: "Sweden",
        fee: "SEK 1145",
        limit: "SEK 24700",
    },
    "INT": {
        title: "International (7-10 business days)",
        description: 'Shipping is $75 USD on all international orders (excluding taxes and customs)'
    },
    "standard": {
        title: 'US Standard (6-9 business days)',
        description: 'Shipping is free for Rebag⁺ members, or $20 in all other cases.'
    },
    "expedited": {
        title: 'US Expedited (3-5 business days)',
        description: 'Shipping is $50 USD on all expedited US orders.'
    }
}

const shipping = [
    {
        key: 'us_standard',
        title: 'US Standard (6-9 business days)',
        description: 'Shipping is free for Rebag⁺ members, or $20 in all other cases.'
    },
    {
        key: 'us_expedited',
        title: 'US Expedited (3-5 business days)',
        description: 'Shipping is $50 on all expedited US orders.'
    },
    {
        key: 'int',
        title: 'International (7-10 business days)',
        description: 'Shipping is $75 on all international orders (excluding taxes and customs). Note: exotic skins cannot be shipped internationally.'
    },
]

const homepage_holiday_promo = {
    is_active: false,
    title: "Holiday Sale",
    desktop_image_url: `${config.MEDIA_URL}/promos/bf-cm-sale-banner-web.jpg`,
    mobile_image_url: `${config.MEDIA_URL}/promos/bf-cm-sale-banner-mob.jpg`,
    href: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&pf_st_availability_hidden=true&pf_t_collections=bc-filter-Holiday+Sale`
}

const slider_responsive = [
    // desktop: default 1300, 4, 4
    // tablet:
    {
        breakpoint: 992,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    },
    // mobile:
    {
        breakpoint: 540,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
]

const signup_messages = {
    'follow': 'Please log in or create an account to follow a clair code',
    'offer': 'Please log in or create an account to get an offer for your item',
    'upload_image': 'Please log in or create an account to submit images for your item',
    'favorites': 'Create an account to keep track of your saved items',
    'trade': 'Please log in or create an account to start a trade',
}

const logout_default = {
    title: 'Log Out',
    message: 'Are you sure you want to log out?',
    yesActionLabel: 'Yes',
    yesAction: null,
    noActionLabel: 'No',
    noAction: null
}

const vip_filters = [
    {name: "Available", key: "sold", value: '0'},
    {name: "All", key: "", value: ''},
    {name: "Sold", key: "sold", value: '1'},
    {name: "VIP Items", key: "vip", value: '1'},
    {name: "Non-VIP Items", key: "vip", value: '0'}
]
const favorites_sorting = [
    {"name": "Date Added", "param": "date_added"},
    {"name": "Designer A - Z", "param": "designer"},
    {"name": "Price Low to High", "param": "price"},
    {"name": "Price High to Low", "param": "-price"},
]

const rewards_tiers_details_headers = {
    "vertical_header": [
        {
            class: "corner",
            title: "THE PERKS",
            text: "Last 12 months $ transactions",
            hide_from_perks: true
        },
        {
            class: "",
            title: "",
            text: "VIP Preview of New Arrivals",
            hide_from_perks: true
        },
        {
            class: "",
            title: "",
            text: "Early Access to Sales",
            hide_from_perks: true
        },
        {
            class: "",
            title: "",
            text: "Free Shipping & Returns",
            hide_from_perks: true
        },
        {
            class: "",
            title: "",
            text: "Dedicated Support",
            hide_from_perks: true
        },
        {
            class: "",
            title: "",
            text: "Your Special Day Discount",
            hide_from_perks: true
        },
        {
            class: "",
            title: "",
            text: "Surprise Rewards",
            hide_from_perks: true
        },
    ],
    "tier_1": [
        {
            class: "bronze",
            title: "Bronze",
            text: "$500",
            hide_from_perks: true
        },
    ],
    "tier_2": [
        {
            class: "silver",
            title: "Silver",
            text: "$2,500",
            hide_from_perks: true
        },
    ],
    "tier_3": [
        {
            class: "gold",
            title: "Gold",
            text: "$5,000",
            hide_from_perks: true
        },
    ],
    "tier_4": [
        {
            class: "diamond",
            title: "Diamond",
            text: "$10,000",
            hide_from_perks: true
        },
    ]
}

const style_assembly_influencer_list = [
    {
        id: 1,
        image: `${config.MEDIA_URL}/img/style-assembly/lauren_singer_2.jpg`,
        product_collage_image: ``,
        pre_title: "",
        title: "Lauren Singer",
        slider_title: "Shop Lauren's Edit",
        text: "Founder & CEO of Package Free",
        quote: "",
        description: "",
        placeholder_text: "",
        shop_filter: {
            "bc-filter-Lauren's Edit": "Lauren"
        },
        shop_collection_handle: "lauren-singer",
        shop_displayed_collection: "",
        vault_url: `${config.host_rebag_vault}/style-assembly-lauren-singer/`
    },
    {
        id: 2,
        image: `${config.MEDIA_URL}/img/style-assembly/summer_albarcha_2.jpg`,
        product_collage_image: ``,
        pre_title: "",
        title: "Summer Albarcha",
        slider_title: "Shop Summer's Edit",
        text: "Modest Style Expert",
        quote: "",
        description: "",
        placeholder_text: "",
        shop_filter: {
            "bc-filter-Summer's Edit": "Summer"
        },
        shop_collection_handle: "summer-albarcha",
        shop_displayed_collection: "",
        vault_url: `${config.host_rebag_vault}/style-assembly-spotlight-summer-albarcha/`
    },
    {
        id: 3,
        image: `${config.MEDIA_URL}/img/style-assembly/bridget_bahl_2.jpg`,
        product_collage_image: ``,
        pre_title: "",
        title: "Bridget Bahl",
        slider_title: "Shop Bridget's Edit",
        text: "Digital Creator & Entrepreneur",
        quote: "",
        description: "",
        placeholder_text: "",
        shop_filter: {
            "bc-filter-Bridget's Edit": "Bridget"
        },
        shop_collection_handle: "bridget-bahl",
        shop_displayed_collection: "",
        vault_url: `${config.host_rebag_vault}/perfectly-curated-with-bridget-bahl/`
    },
    {
        id: 4,
        image: `${config.MEDIA_URL}/img/style-assembly/laura_brown_2.jpg`,
        product_collage_image: ``,
        pre_title: "",
        title: "Laura Brown",
        slider_title: "Shop Laura's Edit",
        text: "Editor in Chief of InStyle",
        quote: "",
        description: "",
        placeholder_text: "",
        shop_filter: {
            "bc-filter-Laura's Edit": "Laura"
        },
        shop_collection_handle: "laura-brown",
        shop_displayed_collection: "",
        vault_url: `${config.host_rebag_vault}/all-things-fashion-with-laura-brown/`

    },
    {
        id: 5,
        image: `${config.MEDIA_URL}/img/style-assembly/danielle_prescod_2.jpg`,
        product_collage_image: ``,
        pre_title: "",
        title: "Danielle Prescod",
        slider_title: "Shop Danielle's Edit",
        text: "Author & Co-Founder of 2BG",
        quote: "",
        description: "",
        placeholder_text: "",
        shop_filter: {
            "bc-filter-Danielle's Edit": "Danielle"
        },
        shop_collection_handle: "danielle-prescod",
        shop_displayed_collection: "",
        vault_url: `${config.host_rebag_vault}/danielle-prescods-luxury-investment-strategy/`
    },
    {
        id: 6,
        image: `${config.MEDIA_URL}/img/style-assembly/nikki_ogunnaike_2.jpg`,
        product_collage_image: `${config.MEDIA_URL}/img/style-assembly/nikki_ogunnaike.jpg`,
        pre_title: "Under the influence of ",
        title: "Nikki Ogunnaike",
        slider_title: "Shop Nikki's Edit",
        text: "Digital Director of Harper’s Bazaar",
        quote: "“I always have a soft spot for everything Chanel — a Classic Flap bag never goes out of style.”",
        description: "When it comes to the art of influencing, Bryanboy is a master. As a style blogger, Instagram must-follow, and (most recently) TikTok star, the social media legend has paved the way. The Original Influencer talks to Rebag about custom Hermès bags, what it’s like to have a designer accessory named after you, and more.",
        placeholder_text: "",
        shop_filter: {
            "bc-filter-Nikki's Edit": "Nikki"
        },
        shop_collection_handle: "nikki-ogunnaike",
        shop_displayed_collection: "",
        vault_url: `${config.host_rebag_vault}/giving-the-gift-of-luxury-with-nikki-ogunnaike/`
    },
    {
        id: 7,
        image: `${config.MEDIA_URL}/img/style-assembly/bryanboy_2.jpg`,
        product_collage_image: `${config.MEDIA_URL}/img/style-assembly/bryanboy_collage.jpg`,
        pre_title: "Under the Influence of ",
        title: "Bryanboy",
        slider_title: "Shop Bryanboy's Edit",
        text: "Content Creator & Creative Director",
        quote: "“I always have a soft spot for everything Chanel — a Classic Flap bag never goes out of style.”",
        description: "When it comes to the art of influencing, Bryanboy is a master. As a style blogger, Instagram must-follow, and (most recently) TikTok star, the social media legend has paved the way. The Original Influencer talks to Rebag about custom Hermès bags, what it’s like to have a designer accessory named after you, and more.",
        placeholder_text: "",
        shop_filter: {
            "bc-filter-Bryanboy's Edit": "Bryanboy"
        },
        shop_collection_handle: "bryanboy",
        shop_displayed_collection: "",
        vault_url: `${config.host_rebag_vault}/under-the-influence-of-bryanboy/`
    },
    {
        id: 8,
        image: `${config.MEDIA_URL}/img/style-assembly/corey_stokes_2.jpg`,
        product_collage_image: `${config.MEDIA_URL}/img/style-assembly/corey_stokes_collage.jpg`,
        pre_title: "What’s Trending with ",
        title: "Corey Stokes",
        slider_title: "Shop Corey's Edit",
        text: "Fashion Director of Highsnobiety",
        quote: "“The LV soft trunk was always my favorite bag from the late Virgil Abloh’s time at the storied house. He was always finding ways to reinvent classics from the brand.”",
        description: "As the fashion director of Highsnobiety and stylist to the stars, Corey Stokes is a well-versed (and well-dressed) expert on the latest trends. The tastemaker gives us his take on the top accessory men should invest in, this year’s number one trend, and more.",
        placeholder_text: "",
        shop_filter: {
            "bc-filter-Corey Stokes' Edit": "Corey"
        },
        shop_collection_handle: "corey-stokes",
        shop_displayed_collection: "",
        vault_url: `${config.host_rebag_vault}/whats-trending-with-corey-stokes/`
    },
    {
        id: 9,
        image: `${config.MEDIA_URL}/img/style-assembly/nicky_hilton_2.jpg`,
        product_collage_image: `${config.MEDIA_URL}/img/style-assembly/nicky_collage_2.jpg`,
        pre_title: "The Iconic Style of ",
        title: "Nicky Hilton Rothschild",
        slider_title: "Shop Nicky's Edit",
        text: "Designer & Entrepreneur",
        quote: "A blue jean Kelly has been on my wish list for forever. It’s my favorite shade of blue.",
        description: "Businesswoman, model, fashion designer — we’d call that a triple threat. Nicky Hilton Rothschild has been a fixture of American fashion for two decades and counting. Read on to learn about the style icon’s favorite investment piece, #1 wishlist item, and more.",
        placeholder_text: "",
        shop_filter: {
            "bc-filter-Nicky's Edit": "Nicky"
        },
        shop_collection_handle: "nicky-hilton",
        shop_displayed_collection: "",
        vault_url: `${config.host_rebag_vault}/nicky-hilton-rothschilds-handbag-heaven/`
    },
    {
        id: 10,
        image: `${config.MEDIA_URL}/img/style-assembly/rachel_zoe_2.jpg`,
        product_collage_image: ``,
        pre_title: "Curating the Ultimate Accessories Collection with ",
        title: "Rachel Zoe",
        slider_title: "Shop Rachel's Edit",
        text: "Designer & Entrepreneur",
        quote: "",
        description: "It’s no secret that Rachel Zoe, world-renowned stylist-turned-TV personality, entrepreneur, creative director, and author is known for her ability to inspire and transform. The multi-hyphenate and fashion industry icon sits down with Rebag to reveal her subconscious sources of style inspiration, go-to trick to add drama to any Zoom look, the most coveted Hermès piece in her collection, and more.",
        placeholder_text: "",
        shop_filter: {
            "bc-filter-Rachel's Edit": "Rachel"
        },
        shop_collection_handle: "",
        shop_displayed_collection: "",
        vault_url: ``
    }
]

const clair_trade_carousel = [
    {
        "title": ["Buy This", "Buy This", "Sell This"],
        "img_src": ["clair-trade-case-1-item-1", "clair-trade-case-2-item-1", "clair-trade-case-3-item-1"],
        "text": ["Chloé Nile Crossbody<br />Bag Leather Small", "Prada Re-Edition Shoulder<br />Bag Tessuto Mini", "Bottega Veneta Cassette Chain Crossbody<br />Bag Padded Maxi Intrecciato Leather"],
        "mobile_text": ["Chloé Nile Crossbody Bag Leather Small", "Prada Re-Edition Shoulder Bag Tessuto Mini", "Bottega Veneta Cassette Chain Crossbody Bag Padded Maxi Intrecciato Leather"],
        "price": ["1250", "1115", "2200"],
        "label": ["+$111 sales tax", "+$99 sales tax", "Including $105 incentive"],
    },
    {
        "title": ["Sell That", "Sell That", "Buy That"],
        "img_src": ["clair-trade-case-1-item-2", "clair-trade-case-2-item-2", "clair-trade-case-3-item-2"],
        "text": ["Louis Vuitton Artsy Handbag<br />Monogram Empreinte Leather MM", "Longines Classic Flagship Automatic<br />Watch PVD and Stainless Steel 30", "Cartier Love Band Ring<br />18K Yellow Gold"],
        "mobile_text": ["Louis Vuitton Artsy Handbag Monogram Empreinte Leather MM", "Longines Classic Flagship Automatic Watch PVD and Stainless Steel 30", "Cartier Love Band Ring 18K Yellow Gold"],
        "price": ["1250", "1094", "1410"],
        "label": ["Including $60 incentive", "Including $52 incentive", "+$125 sales tax"],
    },
    {
        "title": ["TRADE & pay nothing", "TRADE & pay the difference", "TRADE: Pay nothing & get extra credit"],
        "img_src": ["clair-trade-money", "clair-trade-money", "clair-trade-money"],
        "text": ["Trade for free", "Pay the rest", "Get a new item and receive<br />extra credit in your account"],
        "mobile_text": ["Trade for free", "Pay the rest", "Get a new item and receive extra credit in your account"],
        "price": ["0", "21", "790"],
        "label": ["The exact trade match", "+$2 sales tax", "Earn lots, pay nothing"],
    }
]

const pdp_app_banner = false;

const about_us_menu = [
    {
        id: 1,
        label: 'About Us'
    },
    {
        id: 2,
        label: 'Our Services'
    },
    {
        id: 3,
        label: 'Affiliates'
    },
    {
        id: 4,
        label: 'Press Mentions'
    },
    {
        id: 5,
        label: 'Testimonials'
    }
]

const gift_collections = [
    {
        title: "Wishlist-Worthy",
        url: `${config.host_rebag_shop}/collections/wishlist-worthy/`
    },
    {
        title: "Can't Go Wrong",
        url: `${config.host_rebag_shop}/collections/cant-go-wrong/`
    },
    {
        title: "Collector's Essentials",
        url: `${config.host_rebag_shop}/collections/collectors-essentials/`
    },
    {
        title: "Handsome Treasures",
        url: `${config.host_rebag_shop}/collections/handsome-treasures/`
    },
];

const plp_availability_options = [
    {
        title: "In Stock",
        value: "true",
    },
    {
        title: "All",
        value: null,
    },
];

const plp_sort_options = [
    {
        title: "Most Popular",
        value: "extra-sort1-descending",
    },
    {
        title: "Newest",
        value: "created-descending",
    },
    {
        title: "Price Low to High",
        value: "price-ascending",
    },
    {
        title: "Price High to Low",
        value: "price-descending",
    },
    {
        title: "Best Selling",
        value: "extra-sort2-ascending",
    },
    {
        title: "% Off Retail",
        value: "extra-sort3-descending",
    },
];

const valid_my_account_tabs = [
    {
        key: "submissions",
        name: "Submissions"
    },
    {
        key: "purchases",
        name: "Purchases"
    },
    {
      key: "consignments",
      name: "Consignments"
    },
    {
        key: "trades",
        name: "Trades"
    },
    {
        key: "favorites",
        name: "Favorites"
    },
    {
        key: "saved-searches",
        name: "Saved Searches"
    },
    {
        key: "clair-codes",
        name: "Clair Codes"
    },
    {
        key: "profile",
        name: "Profile"
    },
    {
        key: "addresses",
        name: "Addresses"
    },
    {
        key: "payment",
        name: "Payment"
    },
    {
        key: "rebag-rewards",
        name: "Rebag⁺ membership"
    },
    {
        key: "wallet",
        name: "Wallet"
    },
    {
        key: "loan-program",
        name: "Loans"
    }
];

const wholesaleDiscountsFilters = {
    "whreduced": "Reduced",
    "whclearancea": "Clearance A",
    "whclearanceb": "Clearance B",
}

const conditionList = [
    "bc-filter-Pristine",
    "bc-filter-Excellent",
    "bc-filter-Great",
    "bc-filter-Very Good",
    "bc-filter-Good",
    "bc-filter-Fair",
];

const consignmentHistoryProgress = [
    {
        id: 0,
        label: "Received",
    },
    {
        id: 1,
        label: "Reviewed",
    },
    {
        id: 2,
        label: "Listed",
    },
    {
        id: 3,
        label: "Sold",
    },
    {
        id: 4,
        label: "Paid",
    },
];

const plpFilters = {
    'pf_t_wholesale_discounts': {},
    'pf_t_vip_preview': {
        manualValues: ["bc-filter-extra-tags-First Look"],
    },
    'pf_t_sale': {},
    'pf_t_categories': {
        manualValues: ["bc-filter-Bags","bc-filter-Accessories","bc-filter-Watches","bc-filter-Jewelry","bc-filter-Apparel","bc-filter-Shoes"],
    },
    'pf_t_bag_type': {
        filterOptionId: 'pf_t_bag_type',
        label: 'Bag Type',
        hidden: true,
        name: 'attributes.pf_t_bag_type',
        prefix: 'bc-filter-',
        values: [
            {handle: "all-bags", id: "83286721", label: "All Bags"},
            {key: "bc-filter-Shoulder Bags"},
            {key: "bc-filter-Cross Body Bags", label: "Cross-Body Bags"},
            {key: "bc-filter-Totes", label: "Tote Bags"},
            {key: "bc-filter-Top Handle", label: "Top Handle Bags"},
            {key: "bc-filter-Clutches", label: "Clutch Bags"},
            {key: "bc-filter-Hobos", label: "Hobo Bags"},
            {key: "bc-filter-Backpacks"},
            {key: "bc-filter-Messenger", label: "Messenger Bags"},
            {key: "bc-filter-Bucket", label: "Bucket Bags"},
        ],
        manualValues: [ "bc-filter-Backpacks", "bc-filter-Belt Bag", "bc-filter-Bowler", "bc-filter-Briefcases", "bc-filter-Bucket", "bc-filter-Clutches", "bc-filter-Cross Body Bags", "bc-filter-Duffles", "bc-filter-Hobos", "bc-filter-Messenger", "bc-filter-Rolling Suitcase", "bc-filter-Satchels", "bc-filter-Shoulder Bags", "bc-filter-Small Goods", "bc-filter-Top Handle", "bc-filter-Totes", "bc-filter-Wallets", "bc-filter-Waist Bag"]
    },
    'pf_t_apparel_type': {
        filterOptionId: "pf_t_apparel_type",
        label: "Apparel Type",
        hidden: true,
        name: "attributes.pf_t_apparel_type",
        prefix: "bc-filter-apparel-type-",
        values: [
            {handle: "all-apparel", id: "287724830897", label: "All Apparel"},
        ],
        manualValues: ["bc-filter-apparel-type-Sweater", "bc-filter-apparel-type-Jacket", "bc-filter-apparel-type-Coat", "bc-filter-apparel-type-Cardigan", "bc-filter-apparel-type-Cape", "bc-filter-apparel-type-Vest", "bc-filter-apparel-type-Hoodie", "bc-filter-apparel-type-Blazer", "bc-filter-apparel-type-Sweatshirt", "bc-filter-apparel-type-Zip Up", "bc-filter-apparel-type-Puffer", "bc-filter-apparel-type-Windbreaker", "bc-filter-apparel-type-Button Up",],
    },
    'pf_t_shoe_type': {
        filterOptionId: "pf_t_shoe_type",
        label: "Shoe Type",
        hidden: true,
        name: "attributes.pf_t_shoe_type",
        prefix: "bc-filter-shoe-style-",
        values: [
            {handle: "all-shoes", id: "287724798129", label: "All Shoes"},
            {"key": "bc-filter-shoe-style-Sandals"},
            {"key": "bc-filter-shoe-style-Sneakers"},
            {"key": "bc-filter-shoe-style-Boots"},
            {"key": "bc-filter-shoe-style-Pumps"},
            {"key": "bc-filter-shoe-style-Loafers"},
            {"key": "bc-filter-shoe-style-Mules"},
            {"key": "bc-filter-shoe-style-Espadrilles"},
            {"key": "bc-filter-shoe-style-Flats"},
            {"key": "bc-filter-shoe-style-Heels"},
        ],
        manualValues: ["bc-filter-shoe-style-Sneakers", "bc-filter-shoe-style-Boots", "bc-filter-shoe-style-Sandals", "bc-filter-shoe-style-Pumps", "bc-filter-shoe-style-Espadrilles", "bc-filter-shoe-style-Loafers", "bc-filter-shoe-style-Mules", "bc-filter-shoe-style-Flats", "bc-filter-shoe-style-Heels", "bc-filter-shoe-style-Clogs", "bc-filter-shoe-style-Oxfords"],
    },
    'pf_t_accessory_type': {
        filterOptionId: 'pf_t_accessory_type',
        label: 'Accessory Type',
        hidden: true,
        name: 'attributes.pf_t_accessory_type',
        prefix: 'bc-filter-accessory-type-',
        values: [
            {handle: "all-accessories", id: "160055558214", label: "All Accessories"},
            {key: "bc-filter-accessory-type-Wallets"},
            {key: "bc-filter-accessory-type-Small Leather Goods"},
            {key: "bc-filter-accessory-type-Bag Accessories"},
            {key: "bc-filter-accessory-type-Belts"},
            {key: "bc-filter-accessory-type-Toiletry Bags"},
            {key: "bc-filter-accessory-type-Hats & Hair Accessories"},
            {key: "bc-filter-accessory-type-Scarves & Shawls", label: "Scarves"},
        ],
        manualValues: ["bc-filter-accessory-type-Bag Accessories", "bc-filter-accessory-type-Belts", "bc-filter-accessory-type-Gloves", "bc-filter-accessory-type-Hats & Hair Accessories", "bc-filter-accessory-type-Home Items", "bc-filter-accessory-type-Scarves & Shawls", "bc-filter-accessory-type-Small Leather Goods", "bc-filter-accessory-type-Sunglasses", "bc-filter-accessory-type-Tech Accessories", "bc-filter-accessory-type-Ties", "bc-filter-accessory-type-Toiletry Bags", "bc-filter-accessory-type-Umbrella", "bc-filter-accessory-type-Wallets"],
    },
    'pf_t_jewelry_type': {
        filterOptionId: "all-jewelry",
        label: "Jewelry Type",
        hidden: true,
        name: "attributes.pf_t_jewelry_type",
        prefix: "bc-filter-jewelry-type-",
        values: [
            {handle: "all-jewelry", id: "233952149681", label: "All Jewelry"},
            {key: "bc-filter-jewelry-type-Necklace", label: "Necklaces"},
            {key: "bc-filter-jewelry-type-Bracelet", label: "Bracelets"},
            {key: "bc-filter-jewelry-type-Ring", label: "Rings"},
            {key: "bc-filter-jewelry-type-Earrings"},
            {key: "bc-filter-jewelry-type-Brooch", label: "Brooches"},
            {key: "bc-filter-jewelry-type-Pendant & Charms", label: "Charms"},
        ],
        manualValues: ["bc-filter-jewelry-type-Necklace", "bc-filter-jewelry-type-Bracelet", "bc-filter-jewelry-type-Ring", "bc-filter-jewelry-type-Earrings", "bc-filter-jewelry-type-Brooch", "bc-filter-jewelry-type-Pendant & Charms", "bc-filter-jewelry-type-Cufflinks", "bc-filter-jewelry-type-Bracelets",],
    },
    'pf_v_designers': {},
    'pf_t_ring_size': {},
    'pf_t_off_retail': {
        manualValues: [ "60% and up", "40%-59%", "20%-39%", "less than 20%" ],
    },
    'pf_t_price': {
        filterOptionId: 'pf_t_price',
        label: 'Price',
        hidden: true,
        name: 'attributes.pf_t_price',
        prefix: 'bc-filter-',
        values: [
            {key: "bc-filter-Under $1,000"},
            {key: "bc-filter-$1,000 to $2,500"},
            {key: "bc-filter-$2‚500 to $5‚000"},
            {key: "bc-filter-$5‚000 to $10‚000"},
            {key: "bc-filter-Over $10‚000"}
        ],
        manualValues: [ "bc-filter-Under $1,000", "bc-filter-$1,000 to $2,500", "bc-filter-$2‚500 to $5‚000", "bc-filter-$5‚000 to $10‚000", "bc-filter-Over $10‚000" ],
    },
    'pf_t_apparel_size': {},
    'pf_t_shoe_size': {},
    'pf_t_gender': {},
    'pf_t_watch_case_size': {
        filterOptionId: "pf_t_watch_case_size",
        label: "Watch Case Size",
        hidden: true,
        name: "attributes.pf_t_watch_case_size",
        values: [
            {handle: "all-watches", id: "233952084145", label: "All Watches"},
        ]
    },
    'pf_t_condition': {
        manualValues: [ "bc-filter-Pristine", "bc-filter-Excellent", "bc-filter-Great", "bc-filter-Very Good", "bc-filter-Good", "bc-filter-Fair", "bc-filter-Outlet" ],
    },
    'pf_t_color': {
        manualValues: ["bc-filter-exterior-color-Black","bc-filter-exterior-color-Blue","bc-filter-exterior-color-Brown","bc-filter-exterior-color-Gold","bc-filter-exterior-color-Gray","bc-filter-exterior-color-Green","bc-filter-exterior-color-Metallic","bc-filter-exterior-color-Multicolor","bc-filter-exterior-color-Neutral","bc-filter-exterior-color-Orange","bc-filter-exterior-color-Pink","bc-filter-exterior-color-Print","bc-filter-exterior-color-Purple","bc-filter-exterior-color-Red","bc-filter-exterior-color-Silver","bc-filter-exterior-color-White","bc-filter-exterior-color-Yellow"],
    },
    'pf_t_stores': {
        manualValues: [ "bc-filter-LA - The Shops at Santa Anita", "bc-filter-Miami - Brickell City Centre", "bc-filter-NYC - Soho", "bc-filter-NYC - Westfield World Trade Center", "bc-filter-Sunrise - Sawgrass Mills", "bc-filter-Online" ],
    },
    'pf_t_material': {},
    'pf_t_collections': {
        manualValues: ["bc-filter-Men's Styles", "bc-filter-Clair Picks", "bc-filter-Vintage", "bc-filter-The Fall Edit" ],
    },
    'pf_st_availability_hidden': {},
    'pf_c_collections_hidden': {
        filterOptionId: "pf_c_collections_hidden",
        label: "Collections Hidden",
        hidden: true,
        name: "attributes.pf_c_collections_hidden",
        values: [
            {"handle": "clair-picks", "id": "280543035569", "label": "Clair Picks", "sort_order": "best-selling"},
            {"handle": "seasonal-edit", "id": "284521398449", "label": "The Fall Edit", "sort_order": "best-selling"},
            {"handle": "vintage", "id": "160312164422", "label": "Vintage", "sort_order": "best-selling"},
            {"handle": "mens-styles", "id": "154508197958", "label": "Men's Styles", "sort_order": "best-selling"},
        ]
    },
    'pf_t_secret_collections_hidden': {
        manualValues: [ "bc-filter-VIP Selects", "bc-filter-December", "bc-filter-EBTH", "bc-filter-EBTH07", "bc-filter-PREBF", "bc-filter-B2BF", "bc-filter-VIP LIST", "bc-filter-EBTHFEB", "bc-filter-VIPFEB" ],
    },
    'pf_t_extra_tags_hidden': {
        manualValues: [ "bc-filter-extra-tags-trending", "bc-filter-extra-tags-investment_piece", "bc-filter-extra-tags-high_percent_off_retail", "bc-filter-extra-tags-First Look" ],
    },
    'pf_t_first_look_hidden': {
        manualValues: [ "bc-filter-extra-tags-First Look", "bc-filter-General View" ],
    },
    'pf_t_model': {},
    'pf_t_style': {},
    'pf_t_bag_size': {},
    'pf_t_clearance_discount': {
        manualValues: ["bc-filter-Up to 20% off", "bc-filter-Up to 30% off", "bc-filter-Up to 40% off", "bc-filter-Last Call"],
    },
    'pf_t_featured_sale': {},
}

const subscription_discount_thresholds = [
    {
        threshold: 6000,
        discount_type: 'percent',
        discount_amount: 5,
        discount_message: 'Under $6,000',
    },
    {
        threshold: 999999,
        discount_type: 'fixed',
        discount_amount: 300,
        discount_message: 'Over $6,000',
    },
];

const subscriptionCancelationReasons = [
    {
        id: 1,
        title: "The membership is too expensive",
    },
    {
        id: 2,
        title: "I'm not using the membership enough",
    },
    {
        id: 3,
        title: "I found another service that better suits my needs",
    },
    {
        id: 4,
        title: "I'm not satisfied with the quality or benefits offered",
    },
    {
        id: 5,
        title: "Other",
    },
];

export default {
    // Add common config values here
    cookie_domain: '.rebag.com',
    cookie_params: {path: '/', domain: '.rebag.com'},
    release_version: process.env.REACT_APP_VERSION || '20221209.01',
    PLACE_HOLDER: `${config.MEDIA_URL}/img/placeholder-blue.svg`,
    PLACE_HOLDER_ACC: `${config.MEDIA_URL}/img/clair-logo-blue.svg`,
    TRADE_IN_MODAL_CART_IMAGE: `${config.MEDIA_URL}/img/placeholder-multiple-items.png`,
    PRODUCT_NOT_FOUND_MSG: "We're having trouble loading this product page. We've sent the issue to our team. Please, try again later!",
    IMAGE_SUBMISSION_OFFER_WILL_BE_SENT_MSG: 'We have received your image submission and your offer will be sent to you in 3-4 days.',
    outlet_condition: 'Outlet',
    home_mag_items: home_mag_items,
    header_menu_items: header_menu_items,
    footer_nav_container: footer_nav_container,
    footer_nav_container_contact: footer_nav_container_contact,
    footer_disclaimer_container: footer_disclaimer_container,
    remove_price_collections_list: remove_price_collections_list,
    affirm_api: "https://www.affirm.com/api/promos/v2",
    affirm_promo_messaging: false,
    affirm_promo_messaging_date: "May 29 - June 29",
    exotic_materials_list: exotic_materials_list,
    image_sizes: image_sizes,
    hide_estimated_retail_price_below: .95,
    shipping: shipping,
    sell_now_steps_header: sell_now_steps_header,
    homepage_theme_data: homepage_theme_data,
    homepage_holiday_promo: homepage_holiday_promo,
    slider_responsive: slider_responsive,
    site_credit_history: {'credit': 'added', 'cancel': 'cancelled', 'debit': 'used', 'refund': 'refunded', 'expired': 'expired', 'redeemed': 'redeemed'},
    sell_now_image_upload_background_analysis: true,
    recently_viewed_count_min: 2,
    in_cart_count_min: 2,
    signup_messages,
    logout_default,
    vip_filters: vip_filters,
    favorites_sorting,
    style_assembly_influencer_list,
    pdp_app_banner,
    clair_trade_carousel,
    about_us_menu,
    offer_coupon: "RBNEW",
    applied_discount_top_percentage: 0.26, // 26%
    gift_collections,
    page_size: 100,
    first_look_collection: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&pf_st_availability_hidden=true&pf_t_vip_preview=bc-filter-extra-tags-First+Look`,
    rewards_tiers_details_headers,
    vip_preview: {vip_preview_week_day: 3, vip_preview_duration: 24},
    valid_my_account_tabs,
    gfy_min_amount_to_apply: 1000,
    internationalShipping,
    plp_sort_options,
    plp_availability_options,
    conditionList,
    wholesaleDiscountsFilters,
    infinity_value_range: "50-70%",
    consignmentHistoryProgress,
    plpFilters,
    wallet_monthly_percentage: 1.5,
    getReturnPriceBasedOnProductPrice,
    subscription_discount_thresholds,
    subscription_nr_of_days_payment_delay: 5,
    subscriptionCancelationReasons,
    rebag_increase_percent: 10,
    rPlusPercentageUpTo: 5,
    searchDebounceValue: 450,
    SIncentiveBanner: true,
    ...config
};
